import { SEARCH_RESULT_TYPE_PRIORITY } from "./types";

import type SearchEngine from "./SearchEngine";
import type { SearchResult } from "./types";

/**
 * Merges the results of all engines into a single list. Results are ordered by
 * engine priority first (stops before places for mobility customers), then by
 * result type priority and finally by the rank returned by the api.
 */
const mergeSearchResults = (
  resultsByEngine: { engine: SearchEngine; results: SearchResult[] }[],
): SearchResult[] => {
  return resultsByEngine
    .flatMap(({ engine, results }) => {
      return results.map((result) => {
        return { enginePriority: engine.priority, result };
      });
    })
    .sort((a, b) => {
      return (
        a.enginePriority - b.enginePriority ||
        SEARCH_RESULT_TYPE_PRIORITY[a.result.type] -
          SEARCH_RESULT_TYPE_PRIORITY[b.result.type] ||
        a.result.rank - b.result.rank
      );
    })
    .map(({ result }) => {
      return result;
    });
};

export default mergeSearchResults;
